import IntegrationsDashboardTableRow from "./IntegrationsDashboardTableRow";

export default IntegrationsDashboardTableRow;
